import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  width: 100vw;
  height: auto;
  bottom: 0;
  left: 0;
  z-index: 100;
`;

export const ContainerObsoleteMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner-sm);
  padding: var(--spacing-component-inner) 0;

  @media (min-width: 1700px) {
    .text-obsolete {
      font-size: 16px;
    }
  }
`;
